const SESSION_HINT_KEY = 'has_session';

/**
 * Non-authoritative "probably logged in" marker. The real credential is the
 * httpOnly session cookie, which JS cannot read — this hint exists only for
 * synchronous UI decisions (404 redirect, query enabled-gates on public pages)
 * that can't await a network round-trip. Set on session establishment, cleared
 * on logout and on any authenticated 401. A stale hint is harmless: the worst
 * case is one extra request that 401s.
 */
export function hasSessionHint(): boolean {
	return localStorage.getItem(SESSION_HINT_KEY) === '1';
}

export function setSessionHint(): void {
	localStorage.setItem(SESSION_HINT_KEY, '1');
}

export function clearSessionHint(): void {
	localStorage.removeItem(SESSION_HINT_KEY);
}
